var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 451.277 451.277",
    style: {
      enableBackground: "new 0 0 451.277 451.277"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#45B39C"
    },
    cx: 225.638,
    cy: 225.638,
    r: 225.638
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M304.756,117.71h-29.382l-4.513-4.466l-0.235-0.282l-0.564-0.564 c-0.846-0.799-1.975-1.269-3.197-1.269H244.91l-10.249-10.202l-1.504-1.504l-0.006,0.02c-2.138-1.882-4.794-3.114-7.657-3.076 c-6.629,0.047-11.941,5.453-11.941,12.082c0,0.94,0.094,1.833,0.282,2.68h-29.43c-2.163,0-4.043,1.457-4.607,3.573l-0.846,3.009 h-32.438c-4.795,0-8.65,3.855-8.65,8.65v219.922c0,2.539,1.128,4.842,2.868,6.394l98.199,98.199 c107.515-6.25,194.801-87.748,209.989-192.622L310.867,120.201C309.269,118.65,307.154,117.71,304.756,117.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC8744"
    },
    d: "M304.776,117.697H146.501c-4.78,0-8.654,3.875-8.654,8.654v219.915c0,4.78,3.875,8.654,8.654,8.654 h158.274c4.78,0,8.654-3.875,8.654-8.654V126.352C313.43,121.572,309.555,117.697,304.776,117.697z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.055,
    y: 133.837,
    style: {
      fill: "#EBF0F3"
    },
    width: 149.146,
    height: 210.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.055,
    y: 128.113,
    style: {
      fill: "#FFFFFF"
    },
    width: 149.146,
    height: 210.33
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M276.188,131.82l-4.687-17.134c-0.573-2.094-2.475-3.546-4.646-3.546h-29.426 c0.657-2.901,0.503-6.102-2.429-9.823c-2.314-2.937-5.752-5.001-9.491-4.962c-6.629,0.069-11.98,5.464-11.98,12.109 c0,0.922,0.124,1.812,0.319,2.675h-29.426c-2.171,0-4.074,1.452-4.647,3.546l-4.687,17.134c-0.838,3.065,1.469,6.088,4.647,6.088 h91.807C274.72,137.908,277.027,134.885,276.188,131.82z M225.639,114.836c-3.514,0-6.372-2.858-6.372-6.372 c0-3.512,2.858-6.371,6.372-6.371c3.511,0,6.369,2.858,6.369,6.371C232.009,111.978,229.15,114.836,225.639,114.836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M184.13,184.297h-13.943c-3.324,0-6.028-2.704-6.028-6.023V164.33c0-3.324,2.704-6.028,6.028-6.028 h13.943c3.324,0,6.028,2.704,6.028,6.028v13.943C190.157,181.593,187.453,184.297,184.13,184.297z M170.186,163.004 c-0.73,0-1.327,0.597-1.327,1.327v13.943c0,0.73,0.597,1.322,1.327,1.322h13.943c0.73,0,1.327-0.592,1.327-1.322V164.33 c0-0.73-0.597-1.327-1.327-1.327H170.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M184.13,220.805h-13.943c-3.324,0-6.028-2.704-6.028-6.028v-13.943c0-3.32,2.704-6.024,6.028-6.024 h13.943c3.324,0,6.028,2.704,6.028,6.024v13.943C190.157,218.1,187.453,220.805,184.13,220.805z M170.186,199.511 c-0.73,0-1.327,0.592-1.327,1.322v13.943c0,0.73,0.597,1.327,1.327,1.327h13.943c0.73,0,1.327-0.597,1.327-1.327v-13.943 c0-0.73-0.597-1.322-1.327-1.322H170.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M184.13,257.313h-13.943c-3.324,0-6.028-2.704-6.028-6.028v-13.943c0-3.324,2.704-6.028,6.028-6.028 h13.943c3.324,0,6.028,2.704,6.028,6.028v13.943C190.157,254.609,187.453,257.313,184.13,257.313z M170.186,236.015 c-0.73,0-1.327,0.597-1.327,1.327v13.943c0,0.73,0.597,1.327,1.327,1.327h13.943c0.73,0,1.327-0.597,1.327-1.327v-13.943 c0-0.73-0.597-1.327-1.327-1.327H170.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M184.13,293.82h-13.943c-3.324,0-6.028-2.704-6.028-6.028v-13.943c0-3.324,2.704-6.028,6.028-6.028 h13.943c3.324,0,6.028,2.704,6.028,6.028v13.943C190.157,291.116,187.453,293.82,184.13,293.82z M170.186,272.523 c-0.73,0-1.327,0.597-1.327,1.327v13.943c0,0.73,0.597,1.327,1.327,1.327h13.943c0.73,0,1.327-0.597,1.327-1.327v-13.943 c0-0.73-0.597-1.327-1.327-1.327H170.186z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 161.725,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 176.179,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 198.231,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 212.685,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 234.737,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 249.185,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 271.247,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.114,
    y: 285.696,
    style: {
      fill: "#EBF0F3"
    },
    width: 83.656,
    height: 4.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M176.65,177.755c-0.638,0-1.253-0.262-1.703-0.73l-4.908-5.146 c-0.895-0.936-0.858-2.424,0.083-3.324c0.936-0.891,2.424-0.863,3.324,0.083l2.888,3.03c2.938-4.141,9.329-12.102,16.087-13.971 c1.249-0.322,2.548,0.395,2.893,1.644c0.344,1.249-0.39,2.543-1.644,2.893c-6.042,1.666-12.892,10.963-15.022,14.406 c-0.381,0.62-1.029,1.029-1.754,1.102C176.811,177.75,176.733,177.755,176.65,177.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M176.65,213.944c-0.638,0-1.253-0.262-1.703-0.73l-4.908-5.146 c-0.895-0.936-0.858-2.424,0.083-3.324c0.936-0.89,2.424-0.863,3.324,0.083l2.888,3.03c2.938-4.141,9.329-12.102,16.087-13.971 c1.249-0.322,2.548,0.395,2.893,1.644c0.344,1.249-0.39,2.543-1.644,2.892c-6.042,1.667-12.892,10.963-15.022,14.407 c-0.381,0.62-1.029,1.028-1.754,1.102C176.811,213.939,176.733,213.944,176.65,213.944z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M168.763,255.059c-0.601,0-1.202-0.23-1.662-0.689c-0.918-0.918-0.918-2.406,0-3.324l16.789-16.789 c0.918-0.918,2.406-0.918,3.324,0c0.918,0.918,0.918,2.406,0,3.324l-16.789,16.789 C169.966,254.829,169.365,255.059,168.763,255.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M185.553,255.059c-0.601,0-1.203-0.23-1.662-0.689l-16.789-16.789c-0.918-0.918-0.918-2.406,0-3.324 c0.918-0.918,2.406-0.918,3.324,0l16.789,16.789c0.918,0.918,0.918,2.406,0,3.324C186.756,254.829,186.154,255.059,185.553,255.059 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.149f677ba0f609534b9b89ee6c1b845f.svg";
export { ForwardRef as ReactComponent };